import { StyledMarkdown } from "../StyledMarkdown/StyledMarkdown";
import { Link } from "@mui/material";
import { Grid, Box } from "@mui/material";

export const NewsSection = ({ children }) => {
  return (
    <Grid
      item
      container
      component="section"
      xs={12}
      md={12}
      spacing={[0, 0, 6]}
      sx={{
        padding: 0,
        alignContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={12}
        md={3}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Box sx={{ width: [140, 140, "100%"], justifyContent: "center" }}>
          <p style={{ fontSize: 50, textAlign: "center" }}>🙏🏼</p>
          {/* <img
            style={{ width: "100%" }}
            alt="AI Village Logo"
            src="/img/logos/ai-village-logo.png"
          /> */}
        </Box>
      </Grid>
      <Grid item xs={12} md={9}>
        <h2 style={{ margin: "0 0 10px 0" }}>Danke für zwei tolle Jahre!</h2>
        <p style={{ hyphens: "auto" }}>
          Mit dem Abschluss unseres letzten Kurses am 7. Mai 2025 mussten wir
          unser Bootcamp-Programm für Software-Entwickler:innen leider
          einstellen. In den vergangenen zwei Jahren durften wir viele
          motivierte Teilnehmerinnen und Teilnehmer auf ihrem Weg in die
          Tech-Welt begleiten – eine Zeit voller Lernen, Wachstum und
          Inspiration. Wir bedanken uns herzlich bei allen, die Teil dieses
          Weges waren – unseren Alumni, Dozent:innen, Partner:innen und
          Unterstützern. Es war uns eine Freude, euch auf eurer Reise zum
          Entwicklerberuf begleiten zu dürfen. Allen Absolvent:innen wünschen
          wir weiterhin viel Erfolg, Neugier und Leidenschaft für Technologie –
          bleibt in Verbindung!
        </p>
      </Grid>
    </Grid>
  );
};
